export default __webpack_public_path__ + "static/media/got.63210ca9.gif";